import Axios from '../axios';
import appConfig from '../../../app.config';
import { getHeadersWithJwtToken } from '../../../auth/utils/auth-util'
import { TFunction } from 'i18next';
import { logError } from '../../../shared';
import { ICardEnrollment } from '../../interfaces/i-api-creaditCard';

async function setPasswordIdCheckService(cardEnrollment: ICardEnrollment, t: TFunction) {
			const response = await Axios.post(
				`${appConfig.customerDataBaseUrl}/api/enrollment/onlinepurchase/enrollcard`,
				cardEnrollment,
				await getHeadersWithJwtToken()
			).then((data) => {
				if (data.status === 200) {
					return data;
				}
				throw new Error(t('ErrorMsg'))
			}).catch((err) => {
				logError(err)
				throw new Error(t('ErrorMsg'))
			})
			return response;
	}

export default setPasswordIdCheckService;